import React, { useState, useContext } from 'react';
import TopBar from '../builder/Interface/TopBar/TopBar';
import NavList from '../builder/Interface/NavList/NavList';
import styles from './Plan.module.css';
import { Button, Container, ListGroup, Row, Col } from 'react-bootstrap';
import { Check } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import usePurchases from '../../hooks/usePurchases';
import Loader from '../builder/Interface/Loader/Loader';
import { usePageView } from '../../hooks/useAnalytics';
import { PlansContext } from '../../GlobalContex';
import { useNavigate } from 'react-router-dom';

const PLAN_PRICE = 5;

const Plans = () => {
  const { t } = useTranslation();
  const { shown, plan, hidePlan, actions } = useContext(PlansContext);
  const { buy } = usePurchases();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  usePageView('Plans');

  // const monthlyPrice = () => (plan.price / 12).toFixed(2);
  // const dollars = () => String(monthlyPrice()).split('.')[0];
  // const cents = () => String(monthlyPrice()).split('.')[1];

  function buyPlan() {
    setLoading(true);
    buy(plan).then(
      () => {
        setLoading(false);
        navigate('/home');
      },
      err => {
        setLoading(false);
        console.error(err);
      }
    );
  }

  const features = [
    t('5 widgets'),
    t('Unlimited views'),
    t('Unlimited websites'),
    t('Auto-update every 1 hour'),
    t('No ElectricBlaze branding')
  ];

  const handleClick = () => {
    navigate('/home');
  };

  return (
    <React.Fragment>
      <div className={`bootstrap-app-styles builder-styles bg-wite`}>
        <TopBar onClick={handleClick}>{t('Upgrade to Pro')}</TopBar>
        {loading ? (
          <Loader />
        ) : (
          <Container className={styles.plan_card_wrapper}>
            <div className={styles.plan_card}>
              <h1 className={'fs-5 fw-bold text-center'}>{`Start`}</h1>
              <span className={'d-flex justify-content-center'}>
                <h1 className={'fw-bold'}>{`$${PLAN_PRICE}`}</h1>
                <span className={'d-flex align-items-end pb-2 px-1'}>
                  <span>{'/' + t('month')}</span>
                </span>
              </span>
              <p className={'d-flex justify-content-center'}>{t('paid yearly')}</p>
              <ListGroup variant="flush" className={'pt-2 pb-4 px-1'}>
                {features.map((item, i) => (
                  <ListGroup.Item className={styles.plan_card_list} key={i}>
                    <Row>
                      <Col className={'p-0'}>
                        <p className={'fs-6 text-start mb-0'}>{item}</p>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                ))}
              </ListGroup>
              <Button className={'w-100 bg-dark text-white'} onClick={buyPlan}>
                {t('Upgrade')}
              </Button>
            </div>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default Plans;
